<script setup lang="ts">
import { type SaleAssetBusListingItem } from '~/apiClient';
import { NO_VALUE_PLACEHOLDER } from '~/constants/sale';

// COMPOSABLE
const { tt, formatUnits } = useTypedI18n();
const { getPlatformBusClassesLabel } = usePlatformBusClass();
const { formatFirstRegistrationCompact } = useAssetRegistration();

// PROPS
interface Props {
    asset: SaleAssetBusListingItem;
}

const { asset } = defineProps<Props>();
</script>

<template>
    <SlpBaseCard>
        <template #header>
            <SlpCardImages :main-asset="asset" />
        </template>

        <template v-if="!!asset.class" #class> {{ getPlatformBusClassesLabel(asset.class) }} </template>

        <template #model>{{ asset.brand.brandValue }} {{ asset.model.modelValue }}</template>

        <template #registration>{{ formatFirstRegistrationCompact(asset) }}</template>

        <template #kilometer>{{ formatUnits.km(asset.km) ?? NO_VALUE_PLACEHOLDER }}</template>

        <template #euro-norm>{{ asset.euroNorm ? tt(`asset.euroNorm.${asset.euroNorm}`) : '-' }}</template>
    </SlpBaseCard>
</template>
